import type { CheckoutPageEvent, CheckoutPageState } from '~/orderingApp/types';

export const initialState: CheckoutPageState = {
  captcha: {
    captchaMode: null,
    captchaResponse: null,
    resetKey: 0,
  },
  effects: [],
  meta: {
    formSubmissionAttempted: false,
  },
};

export const checkoutPageReducer = (prevState: CheckoutPageState = initialState, event: CheckoutPageEvent) => {
  const nextState = { ...prevState, meta: { ...prevState.meta } };
  switch (event.type) {
    case 'formSubmissionAttempted':
      nextState.meta.formSubmissionAttempted = true;
      if (!nextState.effects.includes('scrollToInvalidInput')) {
        nextState.effects = [...nextState.effects, 'scrollToInvalidInput'];
      }
      break;
    case 'invalidInputScrolledIntoView':
      nextState.effects = nextState.effects.filter(effect => effect !== 'scrollToInvalidInput');
      break;
    case 'ordering.resetPaymentProcessorState':
      // OrderingCaptcha unmounts/remounts together with CheckoutPage, so any
      // preserved captcha token would no longer match the (now unsolved) widget.
      return initialState;
    case 'setDigitalWalletPaymentObject':
      nextState.digitalWalletPaymentObject = event.paymentObject;
      break;
    case 'setCheckoutCaptcha':
      nextState.captcha = {
        ...prevState.captcha,
        captchaMode: event.payload.captchaMode,
        captchaResponse: event.payload.captchaResponse,
      };
      break;
    case 'resetCheckoutCaptcha':
      nextState.captcha = {
        captchaMode: null,
        captchaResponse: null,
        resetKey: prevState.captcha.resetKey + 1,
      };
      break;
    case 'setPendingNcrPaymentSubmission':
      nextState.pendingNcrPaymentSubmission = {
        expectedTotal: event.payload.expectedTotal,
        values: { ...event.payload.values },
      };
      break;
    case 'clearPendingNcrPaymentSubmission':
      delete nextState.pendingNcrPaymentSubmission;
      break;
    case 'setPendingAuthorizeNetPaymentSubmission':
      nextState.pendingAuthorizeNetPaymentSubmission = {
        values: { ...event.payload.values },
      };
      break;
    case 'clearPendingAuthorizeNetPaymentSubmission':
      delete nextState.pendingAuthorizeNetPaymentSubmission;
      break;
    case 'setIsNcrOrderSubmittingInBackground':
      nextState.isNcrOrderSubmittingInBackground = event.payload;
      break;
    case 'setIsToastHostedCheckoutProcessing':
      nextState.isToastHostedCheckoutProcessing = event.payload;
      break;
    case 'setSelectedPaymentMethod':
      nextState.selectedPaymentMethod = event.payload;
      break;
    case 'setIsPaymentProcessingModalOpen':
      nextState.isPaymentProcessingModalOpen = event.payload;
      break;
    case 'ordering.alert':
      if (nextState.isPaymentProcessingModalOpen) nextState.isPaymentProcessingModalOpen = false;
      break;
    case 'ordering.viewUpdatedPrices':
      if (!nextState.effects.includes('scrollToItemSummary')) {
        nextState.effects = [...nextState.effects, 'scrollToItemSummary'];
      }
      if (event.context?.isMobile) {
        nextState.effects = [...nextState.effects, 'expandItemSummary'];
      }
      break;
    case 'expandItemSummaryComplete':
      nextState.effects = nextState.effects.filter(effect => effect !== 'expandItemSummary');
      nextState.effects = nextState.effects.filter(effect => effect !== 'scrollToItemSummary');
      break;
    default:
      break;
  }
  return nextState;
};
